var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1321316608"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 131",
    cx: 36,
    cy: 36.5742,
    r: 35.5,
    fill: "#F4F5F7",
    stroke: "#EBEFF4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82324 59.8079C14.4364 53.7449 21.0693 49.3021 28.7189 47.4826C24.1031 44.7981 21 39.7986 21 34.0742C21 25.5138 27.9396 18.5742 36.5 18.5742C45.0604 18.5742 52 25.5138 52 34.0742C52 39.7986 48.8969 44.7981 44.2811 47.4826C51.673 49.2408 58.1155 53.4486 62.7037 59.2008C56.2836 66.7702 46.7028 71.5742 36 71.5742C25.5862 71.5742 16.2346 67.0261 9.82324 59.8079Z",
    fill: "#8F939C",
    fillOpacity: 0.21
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImagePlaceholder);
export default __webpack_public_path__ + "static/media/profile-image-placeholder.a55d02d69d10752fdf8efe6c2f7a1590.svg";
export { ForwardRef as ReactComponent };